// src/services/api/profile.js
// Profile updates, locale, and timezone functions.

import { fetchWithCommonHeaders, API_URL } from './helpers';

export const updateProfile = async (token, field, value) => {
    const url = `${API_URL}v2/profile/change`;
    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { field, value },
    });
    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.result) {
                errorResult = data.result;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }
    return response.json();
};

export const updateLocale = async (token, locale) => {
    return updateProfile(token, 'locale', locale);
};

export const fetchProfile = async (token) => {
    const url = `${API_URL}v2/profile/view`;
    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
    });
    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.result) {
                errorResult = data.result;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }
    return response.json();
};
